import React from "react";
import {
  Text,
  SectionList,
  StyleSheet,
  View,
  Image,
  TouchableOpacity,
} from "react-native";
import { useSelector } from "react-redux";
import { useNavigation } from "@react-navigation/native";

export default function TransactionList() {
  const navigation = useNavigation();
  const originalData = useSelector(
    (state) => state.transaction.processedTransactions
  );

  const Item = ({ title }) => (
    <TouchableOpacity
      style={styles.container}
      onPress={() =>
        navigation.navigate("SpendingInsightsDetail", { transaction: title })
      }
    >
      <View style={styles.item}>
        <View style={styles.colA}>
          <Image
            style={styles.imageThumbnail}
            source={{ uri: title.partnerImageUrl }}
            resizeMode="contain"
          />
        </View>
        <View style={styles.colB}>
          <Text style={styles.titleCat}>{title.partnerCategoryName}</Text>
          <Text style={styles.titleName}>{title.partnerName}</Text>
          <Text style={styles.titleType}>{title.transactionState}</Text>
        </View>
        <View style={styles.colC}>
          <Text style={styles.titlePaid}>
            -${title.totalAmountPaid.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
          </Text>
          <Text style={styles.titleInvested}>
            REWARD +${title.amountInvested.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
          </Text>
          <Text style={styles.titleDonated}>
            DONATED +${title.amountDonated.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
          </Text>
        </View>
      </View>
    </TouchableOpacity>
  );
  return (
    <View>
      <SectionList
        style={styles.sectionList}
        sections={Object.values(originalData).reverse()}
        keyExtractor={(item, index) => item + index}
        renderItem={({ item }) => <Item title={item} />}
        renderSectionHeader={({ section: { title } }) => (
          <View style={styles.itemHeader}>
            <View style={styles.colA}></View>
            <View style={styles.colD}>
              <Text style={styles.header}>{title}</Text>
            </View>
          </View>
        )}
        ListHeaderComponent={<View style={styles.listHeader}></View>}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  sectionList: {},

  listHeader: {
    height: 215,
  },
  

  listHeaderYellow: {
    height: 230,
  },

  container: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#dddddd",
  },
  item: {
    flex: 1,
    flexDirection: "row",
    paddingTop: 10,
    paddingBottom: 10,
    paddingRight: 10,
    paddingLeft: 10,
    backgroundColor: "#ffffff",
  },

  itemHeader: {
    flex: 1,
    flexDirection: "row",
    paddingTop: 12,
    paddingBottom: 12,
    paddingRight: 10,
    paddingLeft: 10,
  },
  colA: {
    flex: 5,
  },
  colB: {
    flex: 13,
  },
  colC: {
    flex: 7,
  },

  colD: {
    flex: 21,
  },
  row: {
    padding: 15,
    marginBottom: 5,
    backgroundColor: "#ffffff",
  },
  rowDark: {
    padding: 15,
    marginBottom: 5,
    backgroundColor: "#ffffff",
  },

  header: {
    color: "#ffffff",
    fontFamily: "montserrat-bold",
    fontSize: 18,
    textAlign: "left",
  },
  imageThumbnail: {
    flex: 1,
    height: 50,
    width: 50,
    resizeMode: "contain",
    margin: 1,
  },

  titleCat: {
    color: "#998FA2",
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "left",
    paddingBottom: 5,
  },

  titleName: {
    color: "#000000",
    fontFamily: "montserrat-regular",
    fontSize: 15,
    textAlign: "left",
    paddingBottom: 5,
  },

  titleType: {
    color: "#998FA2",
    fontFamily: "montserrat-regular",
    fontSize: 10,
    textAlign: "left",
  },

  titlePaid: {
    color: "#998FA2",
    fontFamily: "montserrat-regular",
    fontSize: 15,
    textAlign: "right",
    paddingBottom: 5,
  },

  titleInvested: {
    color: "#4DCAEF",
    fontFamily: "montserrat-regular",
    fontSize: 10,
    textAlign: "right",
    paddingBottom: 5,
  },

  titleDonated: {
    color: "#4DCAEF",
    fontFamily: "montserrat-regular",
    fontSize: 10,
    textAlign: "right",
  },
});
